import { writeToClipboard } from './clipboard';

// Native share sheet with a clipboard fallback. Nothing is sent anywhere by us:
// the payload is plain text plus the public irecommend link.

export const canShare = () => typeof navigator !== 'undefined' && Boolean(navigator.share);

// Someone else's recommendation is shared UNATTRIBUTED. Naming the author would
// leak both their identity and the fact that the two of you are connected, so
// the quote travels without them. Your own is yours to sign.
export const shareTextFor = (rec, isOwn) => {
  const lines = [
    isOwn
      ? `I recommend ${rec.name} — ${rec.category}.`
      : `${rec.name} — ${rec.category}.`,
  ];
  if (rec.reason) lines.push(`"${rec.reason}"`);
  lines.push(
    isOwn
      ? 'Shared from irecommend.'
      : 'A recommendation from someone I trust on irecommend.',
  );
  return lines.join('\n');
};

let sharing = false;

// Must be called straight from a tap: iOS rejects a share that is not rooted in
// a user gesture, so never await anything before this.
export const shareOrCopy = async ({ title, text, url }) => {
  if (sharing) return 'busy';
  const message = url ? `${text}\n${url}` : text;

  if (canShare()) {
    sharing = true;
    try {
      await navigator.share({ title, text, url });
      return 'shared';
    } catch (err) {
      // Dismissing the sheet is not a failure and must stay silent.
      if (err?.name === 'AbortError') return 'cancelled';
      console.warn('[share] failed:', err?.name, err?.message);
    } finally {
      sharing = false;
    }
  }

  return (await writeToClipboard(message)) ? 'copied' : 'failed';
};
